import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'
import Footer from './../../Footers/Footer/index.vue'
import ProgressHUD from './../../ProgressHUD/index.vue'
import GoogleMap from './../../GoogleMap/VueGoogleMap.vue'
import BarChart from './BarChart.js'
import { Api, Toast, Helper } from './../../../services'

export default {
  name: 'CarbonMarketDetails',
  props: [],
  components: {
    Header,
    Footer,
    ProgressHUD,
    BarChart,
    GoogleMap,
  },
  data() {
    return {
      data: {
        isLike: false,
        likes: [],
        likesCount: 0,
        project: {
          address: '',
          country: '',
          created: '',
          images: [],
          name: '',
          price: 0,
          size: 0,
          images: [''],
          projectTimeData: [],
          capacitySize: "Mw",
          user: [
            {
              fullName: '',
              projects: [],
            },
          ],
        },
        posts: [],
      },
      datacollection: {
        labels: [],
        actualData: [],
        predictedData: [],
      },
      typeChart: 'week', // two types: "week" or "month"
      userCountProject: 0,
      newPost: {
        id: 0,
        title: '',
        picture: null,
        description: '',
      },
      editPost: {
        id: 0,
        title: '',
        picture: null,
        description: '',
      },
      validationMessage: null,
      search: {
        text: '',
      },
    }
  },
  filters: {
    filterDate(value) {
      if (value) {
        var monthNames = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ]
        var monthNamesShort = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ]

        var date = new Date(value),
          month = monthNamesShort[date.getMonth()],
          day = date.getDate(),
          year = date.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day

        return month + '. ' + day + ', ' + year
      }

      return ''
    },
  },
  methods: {
    payConsultingService() {
      Toast.notImplemented({
        toast: this.$toast,
      })
    },

    parseDate(input) {
      var parts = input.split('/')
      return new Date(parts[0], parts[1] - 1, parts[2])
    },

    isNullOrUndefined(value) {
      return value === null || value === undefined
    },

    // Events click on Tab
    weekChartClick(event) {
      // if value not changes
      if (this.typeChart == 'week') return

      this.typeChart = 'week'
      this.refreshDataForChart()
    },

    monthChartClick(event) {
      // if value not changes
      if (this.typeChart == 'month') return

      this.typeChart = 'month'
      this.refreshDataForChart()
    },

    // Display / refresh data for chart
    refreshDataForChart() {
      if (this.data.project == undefined || this.data.project == null) return

      // set data for charts
      this.datacollection.labels = []
      this.datacollection.actualData = []
      this.datacollection.predictedData = []

      var timeLine = 0
      if (this.typeChart == 'week') timeLine = 7
      else timeLine = 29

      var curentDate = new Date()
      var timePeriod = {
        first: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate() - timeLine
        ),
        last: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate()
        ),
      }

      // Get time period for filter
      for (var indexForIpvData in this.data.project.ipv) {
        var ipvDataByDay = this.data.project.ipv[indexForIpvData]
        if (!ipvDataByDay) {
          console.error('IPV Data is null')
          continue
        }
        var ivpDate = this.parseDate(ipvDataByDay.date)

        if (timePeriod.first <= ivpDate && ivpDate <= timePeriod.last) {
          this.datacollection.labels.push(ipvDataByDay.date)
          this.datacollection.actualData.push(ipvDataByDay.actual)
          this.datacollection.predictedData.push(ipvDataByDay.predict)
        }
      }

      this.datacollection = this.createDataCollection(
        this.datacollection.labels,
        this.datacollection.actualData,
        this.datacollection.predictedData
      )
    },

    // Function for create data collection
    createDataCollection(labels, actualData, predictedData) {
      return {
        labels: labels,
        datasets: [
          {
            label: 'Actual',
            backgroundColor: 'rgba(91, 155, 213, 0.2)',
            borderColor: 'rgba(91, 155, 213, 1)',
            borderWidth: 1,
            data: actualData,
          },
          {
            label: 'Predicted',
            backgroundColor: 'rgba(237, 125, 49, 0.2)',
            borderColor: 'rgba(237, 125, 49,1)',
            borderWidth: 1,
            data: predictedData,
          },
        ],
      }
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files) {
        this.newPost.picture = []
        return
      }

      this.newPost.picture = files
    },

    buyTokens() {
      Toast.notImplemented({
        toast: this.$toast,
      })
    },

    onFileChangeForEditPost(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files) {
        this.editPost.picture = []
        return
      }

      this.editPost.picture = files
    },

    async addNewPost() {
      var self = this

      const isValid = await this.$validator.validateAll('formNewPosts')
      if (!isValid) return

      this.$refs.progress.show()

      var formData = new FormData()
      formData.append('title', self.newPost.title)
      formData.append('text', self.newPost.description)
      formData.append('files0', self.newPost.picture[0])
      formData.append('project_id', self.data.project._id)

      var response = await Api.addPostToProject(formData)
      if (response.data) {
        // Add new post to list posts
        this.data.posts.push(response.data.post)

        // Set empty value in form for New Post
        self.newPost.id = 0
        self.newPost.title = ''
        self.newPost.description = ''
        self.newPost.picture = []

        this.$refs.Picture.value = ''
        this.$refs.Picture2.value = ''

        $('#modalAddPost').modal('close')
      } else {
        console.log(response.message)
        alert('Error: ' + response.message)
      }

      this.$refs.progress.hide()
    },

    async saveEditPost() {
      var self = this

      const isValid = await this.$validator.validateAll('formEditPosts')
      if (!isValid) return

      this.$refs.progress.show()

      var formData = new FormData()
      formData.append('id', self.editPost.id)
      formData.append('title', self.editPost.title)
      formData.append('text', self.editPost.description)
      formData.append('project_id', self.editPost.project_id)

      if (self.editPost.picture && self.editPost.picture[0]) {
        formData.append('files0', self.editPost.picture[0])
      }

      var response = await Api.editPostInProject(formData)
      if (response.data) {
        // Edit post
        const post = this.data.posts.find(x => x._id === self.editPost.id)
        post.id = self.editPost._id
        post.title = self.editPost.title

        post.text = self.editPost.description
        post.project_id = self.editPost.project_id

        if (response.data.post.image && response.data.post.image.length > 0) {
          post.image = response.data.post.image
        }

        $('#modalEditPost').modal('close')
      } else {
        console.log(response.message)
        alert('Error: ' + response.message)
      }

      this.$refs.progress.hide()
    },

    openDialogForEditPost(post) {
      this.editPost.id = post._id
      this.editPost.title = post.title
      this.editPost.picture = null
      this.editPost.description = post.text
      this.editPost.project_id = post.project_id

      this.$refs.editPicture.value = ''
      this.$refs.editPicture2.value = ''

      $('#modalEditPost input[name="Title"]')
        .siblings('label')
        .addClass('active')

      $('#modalEditPost textarea')
        .siblings('label')
        .addClass('active')

      $('#modalEditPost').modal('open')
    },

    async removePost(post) {
      this.$refs.progress.show()

      var response = await Api.removePostInProject(post._id)
      if (response.data) {
        this.removeElementInArray(this.data.posts, post)
      } else {
        console.log(response.message)
        alert('Error: ' + response.message)
      }

      this.$refs.progress.hide()
    },

    removeElementInArray(array, element) {
      const index = array.indexOf(element)
      if (index !== -1) {
        array.splice(index, 1)
      }
    },
    changeTypeFilter(type) {
      this.$router.push({ path: `/tradeofco2?type=${ type }` })
    },
    searchClick() {
      this.$router.push({ path: `/tradeofco2?text=${ this.search.text }` })
    },
  },
  async created() {
    var response = await Api.getSystemsDetailById(this.$route.params.id)
    if (response.data && !response.data.error) {
      var resultDate = response.data.results[0]
      if (resultDate) {
        this.data = resultDate

        this.$refs.googleMap.setPosition(
          this.data.project.latitude,
          this.data.project.longitude
        )

        this.refreshDataForChart()
      }
    } else {
      console.error('Something went wrong.')
      this.validationMessage = 'Something went wrong.'
    }

    var response = await Api.getCountProjectsById(this.$route.params.id)
    if (response.data && !response.data.error) {
      this.userCountProject = response.data.results
    } else {
      console.error('Something went wrong.')
    }

    this.$refs.progress.hide()
  },
  async mounted() {
    await new Promise(resolve => this.$nextTick(resolve))

    this.refreshDataForChart()

    jQuery(document).ready(function($) {
      $('[data-toggle="tooltip"]').tooltip()
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/TradeOfCO2/TradeDetails/TradeDetails.component.js